import { sub } from 'date-fns';
// config
import { ASSETS_API } from 'src/config-global';
//
import {
  _id,
  _ages,
  _roles,
  _prices,
  _emails,
  _ratings,
  _nativeS,
  _nativeM,
  _nativeL,
  _percents,
  _booleans,
  _sentences,
  _lastNames,
  _fullNames,
  _tourNames,
  _jobTitles,
  _taskNames,
  _postTitles,
  _firstNames,
  _fullAddress,
  _companyNames,
  _productNames,
  _descriptions,
  _phoneNumbers,
} from './assets';

// ----------------------------------------------------------------------

export const _mock = {
  id: (index) => _id[ index ],
  time: (index) => sub(new Date(), { days: index, hours: index }),
  boolean: (index) => _booleans[ index ],
  role: (index) => _roles[ index ],
  // Text
  taskNames: (index) => _taskNames[ index ],
  postTitle: (index) => _postTitles[ index ],
  jobTitle: (index) => _jobTitles[ index ],
  tourName: (index) => _tourNames[ index ],
  productName: (index) => _productNames[ index ],
  sentence: (index) => _sentences[ index ],
  description: (index) => _descriptions[ index ],
  // Contact
  email: (index) => _emails[ index ],
  phoneNumber: (index) => _phoneNumbers[ index ],
  fullAddress: (index) => _fullAddress[ index ],
  // Name
  firstName: (index) => _firstNames[ index ],
  lastName: (index) => _lastNames[ index ],
  fullName: (index) => _fullNames[ index ],
  companyName: (index) => _companyNames[ index ],
  // Number
  number: {
    percent: (index) => _percents[ index ],
    rating: (index) => _ratings[ index ],
    age: (index) => _ages[ index ],
    price: (index) => _prices[ index ],
    nativeS: (index) => _nativeS[ index ],
    nativeM: (index) => _nativeM[ index ],
    nativeL: (index) => _nativeL[ index ],
  },
  // Image
  image: {
    cover: (index) => `${ASSETS_API}/assets/images/cover/cover_${index + 1}.jpg`,
    avatar: (index) => `${ASSETS_API}/assets/images/avatar/avatar_${index + 1}.jpg`,
    travel: (index) => `${ASSETS_API}/assets/images/travel/travel_${index + 1}.jpg`,
    company: (index) => `${ASSETS_API}/assets/images/company/company_${index + 1}.png`,
    product: (index) => `${ASSETS_API}/assets/images/m_product/product_${index + 1}.jpg`,
    portrait: (index) => `${ASSETS_API}/assets/images/portrait/portrait_${index + 1}.jpg`,
  },
};

export const features = [
  {
    id: '1',
    image: '/assets/images/administror.png',
    title: 'Admin User',
    total: 345,
    color: 'primary',
    path: '/dashboard/admin-users/marketing',
    pending: ''
  },
  {
    id: '2',
    name: 'Analytics',
    icon: 'fluent:chart-24-filled',
    image: '/assets/images/analytic.png',
    title: 'Roles & Permissions',
    total: 568,
    color: 'info',
    path: '/dashboard/role-and-permission',
    pending: ''
  },
  {
    id: '3',
    name: 'Orders',
    icon: 'fluent:cart-24-filled',
    image: '/assets/images/permissio.png',
    title: 'Lead Management',
    total: 120,
    color: 'success',
    path: '/dashboard',
    pending: 'under construction'
  },
  {
    id: '4',
    name: 'Users',
    icon: 'fluent:people-24-filled',
    image: '/assets/images/sales-team.png',
    title: 'Sales Management',
    total: 789,
    color: 'warning',
    path: '/dashboard',
    pending: 'under construction'
  },
  {
    id: '5',
    name: 'Bug Reports',
    icon: 'fluent:bug-24-filled',
    image: '/assets/images/technica.png',
    title: 'Technical Management',
    total: 234,
    color: 'error',
    path: '/dashboard',
    pending: 'under construction'
  },
  {
    id: '6',
    name: 'Revenue',
    icon: 'fluent:money-24-filled',
    image: '/assets/images/packag.png',
    title: 'Product Packages/Plan',
    total: 9567,
    color: 'primary',
    path: '/dashboard/product-packages/feature-cost',
    pending: ''
  },
  {
    id: '7',
    name: 'Support',
    icon: 'fluent:headset-24-filled',
    image: '/assets/images/invoice.png',
    title: 'Billing and Invoices',
    total: 412,
    color: 'info',
    path: '/dashboard/support-tickets',
    pending: 'under construction'
  },
  {
    id: '8',
    name: 'Performance',
    icon: 'fluent:graph-24-filled',
    image: '/assets/images/analytic.png',
    title: 'Report Analytics',
    total: 89,
    color: 'success',
    path: '/dashboard',
    pending: 'under construction'
  }
];


export const chartDataArray = [
  {
    title: "Heartbeat Monitor 1",
    data: [
      [ new Date("2024-01-01").getTime(), 70 ],
      [ new Date("2024-01-02").getTime(), 90 ],
      [ new Date("2024-01-03").getTime(), 60 ],
      [ new Date("2024-01-04").getTime(), 100 ],
    ],
  },
  {
    title: "Heartbeat Monitor 2",
    data: [
      [ new Date("2024-01-01").getTime(), 65 ],
      [ new Date("2024-01-02").getTime(), 85 ],
      [ new Date("2024-01-03").getTime(), 55 ],
      [ new Date("2024-01-04").getTime(), 95 ],
    ],
  },
  {
    title: "Heartbeat Monitor 3",
    data: [
      [ new Date("2024-01-01").getTime(), 75 ],
      [ new Date("2024-01-02").getTime(), 95 ],
      [ new Date("2024-01-03").getTime(), 65 ],
      [ new Date("2024-01-04").getTime(), 105 ],
    ],
  },
];
export const chartDataArrayLast = [
  {
    title: "Heartbeat Monitor 1",
    data: [
      [ new Date("2024-01-01").getTime(), 70 ],
      [ new Date("2024-01-02").getTime(), 90 ],
      [ new Date("2024-01-03").getTime(), 60 ],
      [ new Date("2024-01-04").getTime(), 100 ],
    ],
  }
];


export const optionsdata = [
  { title: 'High', year: 1994 },
  { title: 'Medium', year: 1972 },
  { title: 'Low', year: 1974 },

];


export const labels = [
  {
    mainLabel: "Dashboard",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "User Management",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Workflow  Management",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Lead Management",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Sales Manager",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Demo Manager ",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Marketing Manger",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Technical Database",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "CRM",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Billing and Invoices",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Demo Mangement",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Support Tickets",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Products and Updates",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "CMS",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Reports and Analytics",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Technical Database",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Marketing Tools",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  },
  {
    mainLabel: "Prompts Management",
    subOptions: [ "View Only", "Edit", "Create", "Delete", "Assign" ]
  }
];